import { render } from "./MyThanks.vue?vue&type=template&id=4cb317d7"
import script from "./MyThanks.vue?vue&type=script&lang=js"
export * from "./MyThanks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__